<template>
  <div :id="component_id">
    <div class="flex-1 justify-start items-center gap-2 cursor-pointer" :class="citationsList.length > 0 ? 'flex' : 'hidden'" @click="viewSources">
      <div class="flex items-center">
        <img v-for="(citation, idx) in citations_sources" :key="idx" :src="getSourceIcon(citation)" :alt="citation"
          :style="idx > 0 ? { marginLeft: '-6px' } : {}" class="w-5 h-5 border border-border-separator rounded-full" />
      </div>
      <span class="text-text-subtle text-sm font-bold leading-4 tracking-tight">{{ $t('messaging.citations.sources') }}</span>
    </div>

    <!-- Modal Dialog -->
    <dialog-modal :isOpen="show_dialog" :showCloseButton="true" backdropType="gray" :title="$t('messaging.citations.title')" @close="closeDialog">
      <!-- Main Content Slot -->
      <div v-for="(citation, idx) in citations_list_unique" class="self-stretch flex flex-col justify-center items-start gap-1 pb-2">
        <div class="self-stretch inline-flex justify-start items-center gap-2">
          <img :key="idx" :src="getSourceIcon(citation.sourceSystem)" :alt="citation.sourceSystem" class="w-5 h-5 border border-border-separator rounded-full" />
          <div class="flex justify-start items-center gap-1">
            <div class="justify-start text-text-default/80 text-sm leading-5 tracking-tight">{{ citation.sourceSystem }}</div>
            <a v-if="isBrowserLink(citation.sourceUrl)" :href="safeUrl(citation.sourceUrl)" target="_blank" rel="noopener noreferrer" :title="$t('messaging.citations.openSource')"><i class="ri-external-link-line ri-125" /></a>
          </div>
        </div>
        <div class="self-stretch">
          <div class="w-80 justify-start text-text-default text-sm font-bold leading-4 tracking-tight">{{ citation.sourceName }}</div>
        </div>
      </div>
    </dialog-modal>
  </div>
</template>

<script>
import DialogModal from './DialogModal.vue';
import { safeUrl } from '../../utils/sanitizeHtml';
import AutoVisionIcon from '@images/auto_vision_icon.svg';
import CuratorIcon from '@images/curator_icon.svg';
import FocusIcon from '@images/focus_icon.svg';
import GubagooIcon from '@images/gubagoo_icon.svg';
import HelpIcon from '@images/help_icon.svg';
import KeyTrakIcon from '@images/keytrak_icon.svg';
import ReconVisionIcon from '@images/recon_vision_icon.svg';
import ReverseRiskIcon from '@images/reverse_risk_icon.svg';
import ReynoldsIcon from '@images/reynolds_icon.svg';

export default {
  props: {
    citationsList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
  },
  components: {
    'dialog-modal': DialogModal
  },
  data() {
    return {
      show_options: false,
      send_message: '',
      show_dialog: false
    }
  },
  computed: {
    component_key() {
      return this.$attrs.key?this.$attrs.key:('tool_citations_'+Date.now());
    },
    component_id() {
      return this.component_key+'_container';
    },
    auto_vision_icon() {
      return AutoVisionIcon;
    },
    curator_icon() {
      return CuratorIcon;
    },
    focus_icon() {
      return FocusIcon;
    },
    gubagoo_icon() {
      return GubagooIcon;
    },
    help_icon() {
      return HelpIcon;
    },
    keytrak_icon() {
      return KeyTrakIcon;
    },
    recon_vision_icon() {
      return ReconVisionIcon;
    },
    reverse_risk_icon() {
      return ReverseRiskIcon;
    },
    reynolds_icon() {
      return ReynoldsIcon;
    },
    citations_list_unique() {
      let uniqueCitations = [];
      return this.citationsList.filter(x => {
        let citationStr = `${x.sourceSystem}_${x.sourceType}_${x.sourceName}_${x.sourceUrl}_${(x.parameters || []).join('|')}`;
        if(uniqueCitations.indexOf(citationStr)<0) {
          uniqueCitations.push(citationStr);
          return true;
        }
        
        return false;
      });
    },
    citations_sources() {
      let fieldData = [];
      this.citations_list_unique.forEach(x => {
        if(fieldData.indexOf(x.sourceSystem)<0)
          fieldData.push(x.sourceSystem);
      });
      return fieldData;
    },
  },
  methods: {
    safeUrl,
    // A RAG document-file URL needs the trusted-app bearer, which a browser link does not send: it would
    // open on a 401. Only a server-side relay can use it, so it is not offered as a link here.
    isBrowserLink(url) {
      return !!safeUrl(url) && url.indexOf('/api/rag/documents/') < 0;
    },
    getSourceIcon(sourceSystem, idx=0) {
      switch (sourceSystem) {
        case 'AutoVision':
          return this.auto_vision_icon;
        case 'Curator':
          return this.curator_icon;
        case 'Focus':
          return this.focus_icon;
        case 'Gubagoo':
          return this.gubagoo_icon;
        case 'Help':
          return this.help_icon;
        case 'KeyTrak':
          return this.keytrak_icon;
        case 'ReconVision':
          return this.recon_vision_icon;
        case 'ReverseRisk':
          return this.reverse_risk_icon;
        default:
          return this.reynolds_icon;
      }
    },
    viewSources() {
      this.show_dialog = true;
    },
    closeDialog() {
      this.show_dialog = false;
    },
  },
}
</script>
